<template>
  <div class="yunxiao teacher make-up-add">
    <div class="main">
      <van-form input-align="right">
        <van-cell
          title="校区"
          title-class="abc"
          required
          is-link
          :class="courseAbsentId ? 'disabled' : ''"
          @click="chooseCampus"
        >
          <template>
            <div v-if="params.campusId">
              {{ params.campus.name }}
            </div>
            <div v-else style="color: var(--g5)">请选择</div>
          </template>
        </van-cell>
        <div class="block">
          <van-cell
            title="缺勤课程"
            title-class="abc"
            required
            is-link
            :class="courseAbsentId ? 'disabled' : ''"
            @click="choosePriceItem"
          >
            <template>
              <div v-if="params.curriculumId">
                {{ params.curriculumName }}
              </div>
              <div v-else style="color: var(--g5)">请选择</div>
            </template>
          </van-cell>
          <van-cell
            title="缺勤记录"
            title-class="abc"
            required
            is-link
            :class="courseAbsentId ? 'disabled' : ''"
            @click="chooseAbsentLogs"
          >
            <template>
              <div v-if="courseAbsentIds.length > 0">
                <div class="van-ellipsis">
                  <span v-if="courseAbsentIds.length > 1">
                    已选{{ courseAbsentIds.length }}个学员
                  </span>
                  <span v-else>
                    {{ absentIObjs[0] && absentIObjs[0].studentName }}
                    {{ absentTips[absentIObjs[0].absentStatus] }}
                  </span>
                </div>
                <span
                  v-if="courseAbsentIds.length > 1"
                  @click.stop="showPopup = true"
                  style="color: var(--tlc); font-size: var(--fs-md)"
                >
                  查看已选名单
                </span>
                <div class="van-ellipsis" v-else style="color: var(--g6); font-size: var(--fs-md)">
                  {{ absentIObjs[0].className || '' }}
                  {{ absentIObjs[0].courseStartTime | formatDatetime('MM月dd日') }}({{
                    absentIObjs[0].courseStartTime | getWeek
                  }}) {{ absentIObjs[0].courseStartTime | formatDatetime('hh:mm') }}～{{
                    absentIObjs[0].courseEndTime | formatDatetime('hh:mm')
                  }}
                </div>
              </div>
              <div v-else style="color: var(--g5)">请选择(可多选)</div>
            </template>
          </van-cell>
        </div>
        <div class="block">
          <van-cell title="补课安排" :is-link="!disableChooseArrange" required @click="selectArrange">
            <template>
              <div v-if="arrange">
                <div class="van-ellipsis">
                  {{ arrange.curriculumName }}
                </div>
                <div class="van-ellipsis" style="color: var(--g6); font-size: var(--fs-md)">
                  {{ arrange.className || '' }}
                  {{ arrange.startTime | formatDatetime('MM月dd日') }}({{
                    arrange.startTime | getWeek
                  }}) {{ arrange.startTime | formatDatetime('hh:mm') }}～{{
                    arrange.endTime | formatDatetime('hh:mm')
                  }}
                </div>
              </div>
              <div v-else style="color: var(--g5)">请选择</div>
            </template>
          </van-cell>
        </div>
      </van-form>
    </div>
    <page-footer-btn multipleBtns>
      <van-button
        square round
        block
        type="primary"
        @click="submit(false)"
        loading-text="保存中..."
        :loading="submiting"
        data-test="add-communication-page-btn-save"
      >
        提交
      </van-button>
    </page-footer-btn>
    <van-popup
      class="show-choosed-absent-popup"
      v-model="showPopup"
      position="bottom"
      :closeable="!courseAbsentIds.length"
      :style="{ height: '372px' }"
      :safe-area-inset-bottom="true"
    >
      <div class="title">
        已选学员({{ courseAbsentIds.length }})
        <span class="clear-btn" v-if="courseAbsentIds.length" @click="clearAbsentLogs"> 清空 </span>
      </div>
      <div class="body">
        <div class="van-hairline--bottom" v-for="(item, idx) of absentIObjs" :key="item.id">
          <div>
            {{ item.studentName }}
            <span style="color: var(--g6)">{{ absentTips[item.absentStatus] }}</span>
          </div>
          <div class="l2 van-ellipsis">
            <span v-if="item.coursePlanType === 0">{{ item.className }}&ensp;</span>
            <!-- <span v-else>{{ item.curriculumName }}&ensp;</span> -->
            <span>{{ item.courseStartTime | formatDatetime('MM月dd日') }}</span>
            <span>({{ weekDays[1] }})</span>
            <span
              >{{ item.courseStartTime | formatDatetime('hh:mm') }}～{{
                item.courseEndTime | formatDatetime('hh:mm')
              }}</span
            >
          </div>
          <van-icon name="clear" class="clear-icon" @click="removeAbsentLog(idx)" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: 'makeUpAdd',
  data() {
    return {
      pageTitle: '安排补课',
      courseAbsentId: this.$vxRoute.query.id,
      isEdit: Boolean(this.$vxRoute.query.edit),
      courseArrangeId: this.$vxRoute.query.cid,
      courseRemedyId: this.$vxRoute.query.rid,
      params: {
        campusId: app.teacher.campus.id,
        campus: app.teacher.campus,
        priceItemName: '',
        curriculumId: '',
        curriculumName: '',
      },
      courseAbsentIds: [],
      absentIObjs: [],
      campusList: [app.teacher.campus],
      submiting: false,
      arrange: null,
      showPopup: false,
      weekDays: ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      absentTips: ['', '', '', '请假', '未到'],
      disableChooseArrange: false,
    };
  },
  methods: {
    //选择校区
    async chooseCampus() {
      if (this.courseAbsentId) {
        return false;
      }
      let res = await app.x3.side.xsCampus({
        id: this.params.campusId,
        config: {
          must: true,
        },
      });

      this.params.campusId = res.id;
      this.params.campus = res;
      this.updatePriceItemInfos();
      this.clearAbsentLogs();
      this.arrange = null;
    },
    async choosePriceItem() {
      if (this.courseAbsentId) {
        return false;
      }
      let res = await app.x3.side.xsCourse({
        id: this.params.curriculumId,
        params: {
          campusIds: [this.params.campusId],
        },
        filter: {
          enableCampusFilter: false,
        },
        config: {
          radio: true,
          must: true,
        },
      })
      if (res && this.params.curriculumId !== res.curriculumId) {
        this.clearAbsentLogs();
        this.arrange = null;
      }
      this.updatePriceItemInfos(res);
    },
    updatePriceItemInfos(res) {
      this.params.curriculumId = res ? res.id : '';
      this.params.curriculumName = res ? res.curriculumName : '';
    },
    chooseAbsentLogs() {
      if (this.courseAbsentId) {
        return false;
      }
      let { campusId, curriculumId } = this.params;
      if (!curriculumId) {
        this.$toast('请选择缺勤课程');
        return false;
      }
      app.x3.side
        .xsAbsentLog({
          ids: [...this.courseAbsentIds],
          list: [...this.absentIObjs],
          params: {
            campusId,
            campusIds: [campusId],
            curriculumId,
            studentCourseFeeStatus: 1,
          },
        })
        .then(res => {
          this.courseAbsentIds = res ? res.ids : [];
          this.absentIObjs = res ? res.list : '';
        });
    },
    clearAbsentLogs() {
      this.courseAbsentIds.splice(0);
      this.absentIObjs.splice(0);
    },
    removeAbsentLog(idx) {
      this.courseAbsentIds.splice(idx, 1);
      this.absentIObjs.splice(idx, 1);
    },
    selectArrange() {
      if (this.disableChooseArrange) {
        return
      }
      let { campusId, curriculumId } = this.params;
      if (!curriculumId) {
        this.$toast('请选择缺勤课程');
        return false;
      }
      app.x3.side
        .xsCoureseArrange({
          id: this.arrange ? this.arrange.id : '',
          params: {
            sortType: 1,
            campusId,
            campusIds: [campusId],
            curriculumId,
          },
        })
        .then(res => {
          this.arrange = res;
        });
    },
    submit(checkClassStudentNum) {
      let { campusId, curriculumId } = this.params;
      let { courseAbsentIds, arrange, absentIObjs } = this;
      if (!campusId) {
        this.$toast('请选择校区');
        return false;
      }
      if (!curriculumId) {
        this.$toast('请选择缺勤课程');
        return false;
      }
      if (!courseAbsentIds || !courseAbsentIds.length) {
        this.$toast('请选择缺勤记录');
        return false;
      }
      if (!arrange || !arrange.id) {
        this.$toast('请选择补课安排排课');
        return false;
      }
      this.submiting = true;
      let aip = this.$api.courseRemedyAddRemedy;
      let params = {
        campusId,
        curriculumId,
        remedyCourseArrangeId: arrange.id,
        checkClassStudentNum: !checkClassStudentNum,
        studentAbsentDtos: absentIObjs.map(({ courseSignId, studentId, id, studentName }) => {
          return {
            courseAbsentId: id,
            courseSignId,
            studentId,
            studentName,
          };
        }),
      };
      // 编辑的接口和参数
      if (this.isEdit) {
        aip = this.$api.courseRemedyPut;
        params = {
          courseAbsentId: this.courseAbsentId,
          courseRemedyId: this.courseRemedyId,
          remedyCourseArrangeId: this.arrange.id,
          checkClassStudentNum: !checkClassStudentNum,
        };
      }
      aip(params)
        .then(res => {
          this.submiting = false;
          if (res.code === 200) {
            this.$toast.success('操作成功');
            // if (this.courseAbsentId) {
            app.vue.$emit('add-make-up-success');
            app.vue.$emit('refresh-arrange-students');
            // }
            this.$nextTick(() => {
              this.$router.back();
            });
            return true;
          }
          if (res.code === 830000019) {
            let msgs = res.data.map(({ studentName, msg }) => studentName + msg);
            this.$toast(`${msgs.join('\n')}`);
            return false;
          }
          if (res.code === 830000043) {
            this.$dialog
            .confirm({
              title: '提示',
              message: '学员已满，是否确认继续添加学员',
              confirmButtonText: '继续添加',
              cancelButtonText: '取消',
              confirmButtonColor: 'var(--c1)',
            }).then(res => {
              this.submit(true)
            })
            return
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err => {
          console.log(err);
          this.submiting = false;
        });
    },
    async getDatas() {
      let { courseAbsentId } = this;
      this.showLoading();
      let getCourseAbsent = this.$api.getCourseAbsent({ courseAbsentId });

      getCourseAbsent
        .then(res => {
          if (res.code === 200) {
            this.$toast.clear();
            let { campusId, priceItemName, curriculumId, curriculumName } =
              res.data || {};
            Object.assign(this.params, {
              campusId,
              campus: app.teacher.campusMap[campusId],
              priceItemName,
              curriculumId,
              curriculumName,
            });
            this.courseAbsentIds.push(res.data.id);
            this.absentIObjs.push({ ...res.data });
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err => {
          console.log(err);
        });
      let promiseAll = [getCourseAbsent];
      if (this.isEdit) {
        let getArrange = this.$api
          .getArrange({
            arrangeRecordId: this.courseArrangeId,
          })
          .then(res => {
            if (res.code === 200) {
              this.arrange = res.data;
            }
          });
        promiseAll.push(getArrange);
      }

      try {
        await Promise.all(promiseAll);
        !notShowloading && this.$toast.clear();
      } catch {
        this.$toast.clear();
      }
    },
  },
  created() {
    let { courseAbsentId } = this;
    if (courseAbsentId) {
      this.getDatas();
    }

    if (this.$route.params && this.$route.params.arrange){
      const obj = this.$route.params.arrange;

      this.params.campusId = obj.campusId;
      this.params.campus = app.teacher.campusMap[obj.campusId];
      this.params.priceItemName = obj.priceItemName;
      this.params.curriculumId = obj.curriculumId;
      this.params.curriculumName = obj.curriculumName;
      this.arrange = obj;
    }
    if (this.$route.params && this.$route.params.disableChooseArrange){
      this.disableChooseArrange = true
    }
  },
  components: {
    pageFooterBtn
  }
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.make-up-add {
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow: auto;
    .block {
      margin: calc(var(--gap) * 12) 0;
    }
  }
  .show-choosed-absent-popup {
    display: flex;
    flex-direction: column;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
    color: var(--g8);
    > .title {
      position: relative;
      margin-bottom: calc(var(--gap) * 8);
      height: calc(var(--w) * 48);
      font-size: var(--fs-lg);
      line-height: calc(var(--w) * 48);
      font-weight: 500;
      text-align: center;
      .clear-btn {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        right: calc(var(--gap) * 16);
        color: var(--tlc);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        height: var(--lh-md);
      }
    }
    > .body {
      padding: 0 calc(var(--gap) * 16);
      overflow: auto;
      > div {
        position: relative;
        display: block;
        padding: 0 calc(var(--gap) * 18) calc(var(--gap) * 7) 0;
        margin-bottom: calc(var(--gap) * 16);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        .l2 {
          margin: calc(var(--gap) * 4) 0 0;
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g6);
        }
        .clear-icon {
          position: absolute;
          top: 50%;
          right: 0;
          color: var(--g6);
          transform: translateY(-50%);
        }
      }
    }
  }
  ::v-deep.van-cell.disabled {
    .van-cell__value {
      color: var(--g6);
    }
    .van-cell__right-icon {
      color: var(--g5);
    }
  }
}
</style>
<style lang="scss">
.yunxiao.teacher.make-up-add {
  .main {
    .van-cell__value,
    .van-cell__title,
    .van-field__label,
    .van-field__value {
      color: var(--g8);
    }
    .van-cell__label {
      white-space: nowrap;
    }
    .van-cell__title,
    .van-field__label {
      color: var(--g7);
      flex: unset;
      width: calc(var(--w) * 80);
    }
  }
}
</style>
